export enum CookieTypesEnum {
    NECESSARY = 'NECESSARY',
    PREFERENCES = 'PREFERENCES',
    ANALYTICS = 'ANALYTICS',
    MARKETING = 'MARKETING',
    UNCLASSIFIED = 'UNCLASSIFIED'
}
